import { ComponentChild, h } from 'preact'
import { PureComponent } from 'preact-compat'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../modal'
import Button from '../../../control-components/ui-components/Button'
import Phrase from '../../../libs/translationsUtils/phrase'
import Textarea from '../../../control-components/ui-components/Textarea'
import InputGroup from '../../../control-components/ui-components/InputGroup'
import { t } from '../../../libs/translationsUtils/translations'

interface Props {
  senderUsername: string
  reportedMessage: string
  reason: string
  onReasonChanged: (reason: string) => void
  onReport: () => void
  onCancel: () => void
  errorMessage?: ComponentChild
}

class ReportPrivateMessageModal extends PureComponent<Props> {
  render ({ senderUsername, reportedMessage, reason, onReasonChanged, onReport, onCancel, errorMessage }: Props) {
    const textarea = (
      <Textarea
        class='private-message_report_reason'
        placeholder={t('Forum', 'privateMessages.reportModal.reasons.placeholder')}
        maxLength={1500}
        value={reason}
        onContentChange={onReasonChanged}
        newStyle
        error={!!errorMessage}
        adjustHeight
        isDestination
      />
    )

    return (
      <Modal isOpen size='medium'>
        <ModalHeader title={<Phrase p='privateMessages.reportModal.title' />} onClose={onCancel} />
        <ModalBody>
          <div className='private-message_report-modal'>
            <Phrase p='privateMessages.reportModal.text' />
            <b><Phrase p='privateMessages.reportModal.sender' /></b>
            <div className='private-message_report-sender'>{senderUsername}</div>
            <b><Phrase p='privateMessages.reportModal.message' /></b>
            <div className='private-message_report-message' dangerouslySetInnerHTML={{ __html: reportedMessage }} />
            <InputGroup
              title={<Phrase p='privateMessages.reportModal.reasons' />}
              customInput={textarea}
              error={errorMessage as string}
              showIconBeforeErrorMessage
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button warning onClick={onReport}><Phrase p='privateMessages.reportModal.reportButton' /></Button>
          <Button secondary cancel onClick={onCancel}><Phrase p='privateMessages.reportModal.cancelButton' /></Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ReportPrivateMessageModal
